import type { FC, ReactNode } from 'react';
import type { ViewStyle } from 'react-native';
import { View } from 'react-native';
import type { ListSectionProps, TextProps } from 'react-native-paper';
import { Divider, List, Text } from 'react-native-paper';

import { isEmptyOrNull } from '@/shared/utils/string';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  titleVariant?: TextProps<string>['variant'];
  headerBackgroundColor?: string;
  headerStyle?: ViewStyle;
  left?: ReactNode;
  hideDivider?: boolean;
} & ListSectionProps;

// Todo: background color of header and the section should be by default transparent
// Todo: we can wrap children inside a view and add  a property childrenBackgroundColor so that we do not need to set bg on each ListItems
/**
 * Note: The first ListSection may require addition spacing from above of 8px, e.g. if used in StateView: add viewContentContainerStyle={{ paddingTop: 8 }} (see AppSettingScreen)
 */
export const ListSection: FC<Props> = ({
  title,
  children,
  titleVariant = 'labelLarge',
  headerBackgroundColor,
  headerStyle,
  left,
  hideDivider = false,
  ...rest
}) => {
  const { colors } = useAppTheme();

  return (
    <List.Section
      {...rest}
      style={[{ backgroundColor: colors.onSecondary }, rest.style]}
    >
      {!isEmptyOrNull(title) && (
        <>
          <View
            style={[
              {
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: headerBackgroundColor ?? colors.background
              },
              headerStyle
            ]}
          >
            <List.Subheader style={rest.titleStyle}>
              <Text variant={titleVariant} style={rest.titleStyle}>
                {title}
              </Text>
            </List.Subheader>
            {left}
          </View>
          {!hideDivider && <Divider />}
        </>
      )}
      {children}
    </List.Section>
  );
};
